export type VerificationErrorKind =
  | "malformed"
  | "unavailable"
  | "upstream_failed"
  | "unknown";

export type VerificationError = {
  kind: VerificationErrorKind;
  message: string;
};

export type VerificationDomain = "pan" | "bank" | "gst" | "generic";

const KIND_MESSAGES: Record<
  VerificationErrorKind,
  Record<VerificationDomain, string>
> = {
  malformed: {
    pan: "PAN format is invalid (expected AAAAA0000A).",
    bank: "Please check the account number and IFSC.",
    gst: "GSTIN format is invalid (expected 15 characters, e.g. 29AAGCM1234K1Z5).",
    generic: "Input is malformed.",
  },
  unavailable: {
    pan: "PAN verification is not configured in this environment.",
    bank: "Bank verification is not configured in this environment.",
    gst: "GST lookup is not configured in this environment.",
    generic: "Verification is not configured in this environment.",
  },
  upstream_failed: {
    pan: "PAN verification service failed. Try again.",
    bank: "Verification service failed. Try again.",
    gst: "GST lookup service failed. Try again.",
    generic: "Verification service failed. Try again.",
  },
  unknown: {
    pan: "PAN lookup failed. Try again.",
    bank: "Bank verification failed. Try again.",
    gst: "GST lookup failed. Try again.",
    generic: "Verification failed. Try again.",
  },
};

export function classifyVerificationError(
  err: unknown,
  domain: VerificationDomain = "generic",
): VerificationError {
  const status = (err as { response?: { status?: number } })?.response?.status;
  const kind: VerificationErrorKind =
    status === 400
      ? "malformed"
      : status === 501
      ? "unavailable"
      : status === 502
      ? "upstream_failed"
      : "unknown";
  return { kind, message: KIND_MESSAGES[kind][domain] };
}
